(function(){
document.querySelectorAll('[data-as-picker]').forEach(function(root){
  var tabs=[].slice.call(root.querySelectorAll('[data-pp-tab]')); if(!tabs.length) return;
  function show(k){
    tabs.forEach(function(t){t.setAttribute('aria-selected',t.dataset.ppTab===k?'true':'false')});
    root.querySelectorAll('[data-pp-panel]').forEach(function(p){p.hidden=p.dataset.ppPanel!==k});
    var form=root.closest('form'),tu=form&&form.querySelector('[data-pp-topup]'); if(tu) tu.hidden=(k==='unl');
    var panel=root.querySelector('[data-pp-panel="'+k+'"]'); if(!panel) return;
    if(panel.querySelector('input[name="id"]:checked')) return;
    var r=panel.querySelector('input[name="id"][data-pick]:not(:disabled)')||panel.querySelector('input[name="id"]:not(:disabled)');
    if(r){r.checked=true;r.dispatchEvent(new Event('change',{bubbles:true}))}
  }
  tabs.forEach(function(t){t.addEventListener('click',function(){show(t.dataset.ppTab)})});
  root.addEventListener('keydown',function(e){
    var i=tabs.indexOf(document.activeElement); if(i<0||(e.key!=='ArrowLeft'&&e.key!=='ArrowRight')) return;
    var n=tabs[(i+(e.key==='ArrowRight'?1:tabs.length-1))%tabs.length]; n.focus(); n.click(); e.preventDefault();
  });
});
})();
